





































































































































import mixins from 'vue-typed-mixins'
import ficheImplantationMixin from './ficheImplantationMixin'
import ficheImplantation from './models/ficheImplantation'
import SendDuplicataModel from './models/ficheImplantationDuplicata_EnvoiMail'
import Configuration from '@/configuration/configuration'
import Openable from '@/global/viewmodels/openable'
import { TraitementDuplicataFicheImpantation_Statut, TraitementDuplicataFicheImpantation_Statut_ToText } from '@/domain/TraitementDuplicataFicheImpantation_Statut'
import { TraitementFicheImplantation_Statut, TraitementFicheImplantation_Statut_ToText } from '@/domain/TraitementFicheImplantation_Statut'
import { FicheImplantation_DemandeDuplicata } from '@/domain/FicheImplantation_DemandeDuplicata'

export default mixins(ficheImplantationMixin).extend({
    components: {
        DialogMailImplantation: () => import('./components/DialogMailImplantation.vue')
    },
    data() {
        return {
            nav: 'tab-fiche',
            dialog: new Openable(),
            fichesImplantations: new Array<ficheImplantation>(),
            demandesDuplicata: new Array<FicheImplantation_DemandeDuplicata>(),
            envoiMailDuplicata: new SendDuplicataModel()
        }
    },
    mounted() {
        this.initialize()
    },
    computed: {
        allStatutsFiches() {
            return Object.keys(TraitementFicheImplantation_Statut)
                .filter((key: any) => !isNaN(Number(key)))
                .map(x => ({ val: +x, text: TraitementFicheImplantation_Statut_ToText(+x) }))
        },
        allStatutsDemandes() {
            return Object.keys(TraitementDuplicataFicheImpantation_Statut)
                .filter((key: any) => !isNaN(Number(key)))
                .map(x => ({ val: +x, text: TraitementDuplicataFicheImpantation_Statut_ToText(+x) }))
        },
        headersFicheImplantation(): Array<any> {
            return this.isMobileDevice()
                ? [
                      { text: 'Utilisateur', value: 'utilisateur' },
                      { text: 'Date', value: 'date' }
                  ]
                : [
                      { text: 'Utilisateur', value: 'utilisateur' },
                      { text: 'Client', value: 'client' },
                      { text: 'Date', value: 'date' },
                      { text: '', value: 'idsFichiers', sortable: false },
                      { text: 'Statut', value: 'statut' },
                      { text: 'ADV en charge', value: 'lastUserTraitement' }
                  ]
        },
        headersDemandeDuplicata(): Array<any> {
            return this.isMobileDevice()
                ? [
                      { text: 'Patient', value: 'nomPatient' },
                      { text: 'Date', value: 'date' }
                  ]
                : [
                      { text: 'Utilisateur', value: 'utilisateur' },
                      { text: 'Client', value: 'codeClient' },
                      { text: 'Patient', value: 'nomPatient' },
                      { text: 'Numéro de greffon', value: 'numeroGreffon' },
                      { text: 'Chirurgien', value: 'nomChirurgien' },
                      { text: 'Date', value: 'date' },
                      { text: 'Statut', value: 'statut' },
                      { text: 'ADV en charge', value: 'lastUserTraitement' }
                  ]
        }
    },

    methods: {
        initialize() {
            this.$loader.go()
            this.loadCompany()
            this.getFichesDatatable()?.then(x => this.fichesImplantations.push(...x))
            this.getDemandesDatatable()?.then(x => this.demandesDuplicata.push(...x))
            this.$loader.stop()
        },
        editionStatusFiche(id: number, status: number) {
            this.modificationStatutFiche(id, status).then(x => {
                this.getFichesDatatable()?.then(x => {
                    this.fichesImplantations.length = 0
                    this.fichesImplantations.push(...x)
                })
            })
        },
        editionStatutDemandes(id: number, status: number) {
            this.modificationStatutDemande(id, status).then(x => {
                this.getDemandesDatatable()?.then(x => {
                    this.demandesDuplicata.length = 0
                    this.demandesDuplicata.push(...x)
                })
            })
        },
        envoiDuplicata(item: SendDuplicataModel) {
            this.envoyerMailDuplicataFicheImplantation(item)?.then(() => this.getFichesDatatable())
        },
        downloadFile(fiche: ficheImplantation) {
            if (fiche.idsFichiers.length) {
                const ids = fiche.idsFichiers.join('_')
                window.open(`${Configuration.apiUrl}/api/file/multiple?ids=${ids}`, '_blank')
            } else {
                this.$swal.toast.error("Il n'y a pas de fichiers d'implantation sur cette fiche")
            }
        },
       
        modalEnvoiMailDuplicata(demandeDuplicata: FicheImplantation_DemandeDuplicata) {
            this.dialog.open()
            this.envoiMailDuplicata = new SendDuplicataModel()
            this.envoiMailDuplicata.idDemandeDuplicata = demandeDuplicata.id
        }
    }
})
